define('lq/events/actions/transformRichText',[
    'lq/events/actions/eventAction',
    'lq/richText'
], function (EventAction, richText) {
    'use strict';
    
    function TransformRichText(eventData, eventArg) {
        EventAction.call(this, eventData, eventArg);
        return this;
    }

    EventAction.extend(TransformRichText, EventAction);

    TransformRichText.typeName = 'TransformRichText';

    TransformRichText.prototype.getBatchType = function () {
        return EventAction.DO_NOT_BATCH;
    };

    TransformRichText.prototype.execute = function (continuation, eventActionResponse) {
        var self = this;
        var sourceString = this.piping.parameters.getValue(self.eventData.transform.sourceParameter);

        if (richText.isRichTextString(sourceString)) {
            self.piping.queryDispatcher.dispatch(
                self.eventData.transform.dataSource.id,
                function (response) {
                    var result = self.getResultFromTransform(sourceString, response.Results);
                    self.writeResult(result);
                    continuation();
                });
        } else {
            self.writeResult(sourceString);
            continuation();
        }
    };

    TransformRichText.prototype.getResultFromTransform = function (richTextString, data) {
        var resultingRichText = richText.modelFromRichTextString(richTextString);
        resultingRichText.sections = [];

        var self = this;
        data.forEach(function (dataItem) {
            // WHY: Deserializing again: create new instance of the rich text
            var sections = richText.modelFromRichTextString(richTextString).sections;

            sections.forEach(function (section) {
                section.text = self.getTransformedText(section.text, dataItem);
                resultingRichText.sections.push(section);
            });
        });

        return richText.modelToRichTextString(resultingRichText);
    };

    TransformRichText.prototype.getTransformedText = function (text, dataItem) {
        var caseInsensitiveParameters = {};
        for (var key in dataItem)
            caseInsensitiveParameters[key.toLowerCase()] = dataItem[key];

        var replacePlaceholder = function (match, p1) {
            return caseInsensitiveParameters[p1.toLowerCase()];
        };

        return text.replace(/\{(.+?)\}/g, replacePlaceholder);
    };

    TransformRichText.prototype.writeResult = function (result) {
        if (result === null)
            result = undefined;
        this.piping.parameters.locals.setValue(this.eventData.transform.targetParameter, result);
    };

    return TransformRichText;
});
